import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { MetricTargetOperator } from "../../models/metric.models";

export class MetricMilestoneValidators {
  public static range(target: number, targetOperator: MetricTargetOperator): ValidatorFn {
    return (c: AbstractControl): ValidationErrors | null => {
      if (isNaN(target) || (!c.value && c.value !== 0)) {
        return null;
      }

      if (targetOperator === "at_least" && c.value > target) {
        return { range: true, translate_key: `kr_milestone_milestone_number_below_message` };
      }

      if (targetOperator === "at_most" && c.value < target) {
        return { range: true, translate_key: `kr_milestone_milestone_number_above_message` };
      }

      return null;
    };
  }
}
